var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClutch = function SvgClutch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    "aria-hidden": "true",
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18 36 17.1-12.42-6.53-20.11H7.43L.9 23.58 18 36z",
    fill: "#ffe575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.71 21.55c-.96.86-2.22 1.34-3.61 1.34-3.06 0-5.3-2.25-5.3-5.33s2.17-5.23 5.3-5.23c1.36 0 2.65.45 3.63 1.31l.67.57 2.96-2.96-.74-.67C23.88 9 21.56 8.12 19.1 8.12c-5.5 0-9.49 3.97-9.49 9.41s4.09 9.53 9.49 9.53c2.51 0 4.85-.88 6.57-2.48l.72-.67-3.01-2.96-.67.6Z",
    fill: "#153039"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.96 14.43c1.76 0 3.18 1.42 3.18 3.18s-1.42 3.18-3.18 3.18-3.18-1.42-3.18-3.18 1.42-3.18 3.18-3.18",
    fill: "#153039"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClutch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clutch.e2ed2c82.svg";
export { ForwardRef as ReactComponent };